import * as React from "react";
import { cn } from "@/lib/utils";

export interface SqInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  bgColor?: string;
  outlineColor?: string;
  focusBgColor?: string;
  radius?: number;
  smooth?: number;
  shadow?: "none" | "sm" | "md" | "lg" | "xl";
  hasOutline?: boolean;
}

const SqInput = React.forwardRef<HTMLInputElement, SqInputProps>(
  (
    {
      className,
      type,
      bgColor,
      radius = 8,
      smooth = 1,
      shadow = "none",
      hasOutline = true,
      style,
      ...props
    },
    ref,
  ) => {
    const customCssVars = {
      ...(style || {}),
      ...(bgColor ? { "--sq-fill": bgColor } : {}),
      "--sq-radius": `${radius}px`,
      "--sq-smooth": `${smooth}`,
    } as React.CSSProperties & Record<string, string>;

    return (
      <input
        type={type}
        className={cn(
          "relative flex h-8 w-full px-3 py-1 text-sm bg-transparent file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 border-0 outline-none ring-0 transition-all",
          "squircle squircle-radius-[8px] squircle-smooth-[1] squircle-fill-[white]",
          shadow === "sm" && "drop-shadow-sm",
          shadow === "md" && "drop-shadow-md",
          shadow === "lg" && "drop-shadow-lg",
          shadow === "xl" && "drop-shadow-xl",
          hasOutline && "squircle-outline-[1px] !squircle-outline-color-border-gray",
          bgColor && "[bg:var(--sq-fill)!important]",
          hasOutline && "[--squircle-radius:var(--sq-radius)!important]",
          "[--squircle-smooth:var(--sq-smooth)!important]",
          className,
        )}
        style={customCssVars}
        ref={ref}
        {...props}
      />
    );
  },
);
SqInput.displayName = "SqInput";

export { SqInput };
